<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Cliente
            <router-link :to="{ name: 'Clientes' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreCliente.$model"
                  :isValid="checkIfValid('nombreCliente')"
                  label="Nombre del cliente:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <ExtraConfigInput
              title=""
              parametro="clientes_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Clientes' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              class="px-4 mx-3 btn-lg"
              @click="addCliente()"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Cliente"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import "vue-select/dist/vue-select.css";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'

export default {
  name: "EditarCliente",
  components: {
    ExtraConfigInput
  },
  data() {
    return {
      multi: null,
      id: this.$route.params.id,
      item: {},
      nombreCliente: "",
      isLoading: false,
      isLoadingPage: false,
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreCliente: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
  },

  computed: {
    isValidCliente() {
      return !this.$v.nombreCliente.$invalid;
    },
  },

  watch: {

  },

  created() {
    // Call configuration for show fileds dinamycs


    this.isLoadingPage = true;
    const tra = [
      this.$store.dispatch("customHTTP", {
        schema: "clientes",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      }),

    ];



    // Ultimos cambios, en espera del back, solo descomentar
    Promise.all(tra)
      .then(([item]) => {
        this.item = item.data[0];
        this.nombreCliente = this.item.payload.nombre;
        this.isLoading = false
        this.isLoadingPage = false

        if(this.item.payload.extras !== undefined){
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1]
          }
        }
      })
      .finally(() =>{
        this.isLoadingPage = false
        debugger
      });
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },
    toggleSuspendido() {
      this.suspendido = !this.suspendido
    },
    addCliente() {
      this.validateCliente();


      if (this.isValidCliente) {

          // Ultimos cambios, en espera del back, solo descomentar
          // const newUbicaciones =
          //   this.multi &&
          //   this.multi.map(ubi => {
          //     return ubi.value;
          //   });


          this.fieldsExtraConfig.forEach(indexField => {
            if (indexField.tipo === "number") {
              this.fieldsExtra[indexField.nombre] =
                Number(this.fieldsExtra[indexField.nombre]) || 0;
            }
            if (indexField.tipo === "text") {
              this.fieldsExtra[indexField.nombre] =
                this.fieldsExtra[indexField.nombre] || "";
            }
          });


          this.$store
            .dispatch("customActualizarHTTP", {
              schema: "clientes",
              id: this.id,
              payload: {
                nombre: this.nombreCliente,
                ...(this.fieldsExtraConfig.length > 0)?{extras: this.fieldsExtra}:{},
              }
            })
            .then(() => {
              // console.log(res.data);
              this.$router.push({ name: "Clientes" });
            })
            .catch(rej => {
              // console.log(rej);
              this.error = rej.message;
              this.warningModal = true;
            })

            .finally(() => {
              this.isLoading = false;
            });


      }
    },
    addClienteFull() {
      // Ultimos cambios, en espera del back, solo descomentar
      // const newUbicaciones =
      //   this.multi &&
      //   this.multi.map(ubi => {
      //     return ubi.value;
      //   });

      this.isLoading = true;
      this.$store
        .dispatch("customActualizarHTTP", {
          schema: "clientes",
          id: this.id,
          payload: {
            nombre: this.nombreCliente,
          }
        })
        .then(() => {
          // console.log(res.data);
          this.$router.push({ name: "Clientes" });
        })
        .catch(rej => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateCliente() {
      this.$v.nombreCliente.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    cleanMulti() {
      this.multi = [];
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.sp-width {
  max-width: 400px !important;
  height: auto !important;
  /* object-fit: contain; */
}
.cursor-p {
  cursor: pointer;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
